import { changeLocale } from './locale';
import { toggleTheme } from './theme';
import { getXsrf } from './xsrf';
function enable() {
    localStorage.setItem('devtools', 'true');
    window.location.reload();
}
/**
 * Attach devtool functions to window object.
 */
const setupDevTools = () => {
    window.__devtools = {
        changeLocale,
        toggleTheme,
        getXsrf,
        enable,
    };
};
if (window && window.__devtools === undefined) {
    setupDevTools();
}
